export const API = {
  QUERY_ROLE: '/getAmsRoleList',
  AMS_DELIVER: '/awardPrizeV2',
  MULTIPLE_LOTTERY: '/drawV2',
  FREE_LOTTERY: '/drawV2',
  FREE_LOTTERY_CHANCE: '/getRemainingDrawsCount',
  LOTTERY_RESULT: '/drawResults', // 抽奖结果
  RANK_TOP_LOTTERY_RECORD: '/queryPrizesByGameCode',
  MULTIPLE_LOTTERY_COUNT: '/getRemainingDrawsCount',
  USER_ORDER: '/queryUserOrderStatus',
  PLACE_ORDER: '/orderPackage',
  GAME_CARD_PLACE_ORDER: '/v2/placeOrder',
  SEND_SMSCODE: '/orderSmsCode',
  SUBMIT_ORDER: '/submitOrder',
  LOTTERY_REQ: '/lotteryPrizeDeliverV2',
  SYNTHESISTYPE_DELIVER: '/lotteryPrizeDeliverV2',
  GET_USER_PRIZELIST: '/getUserPrizeList',
  SAVE_DELIVER_USER_INFO: '/saveDeliverUserInfo',
  PKG_LIST: '/packageList',
  GET_REDEEMCODE: '/getRedeemCode',

  // 获取openid
  MDSK_DECRYPT: '/decryptMSDKEncodeParam',
  // non-msdk
  ACTIVE: '/activate',
  APPLY_ACTIVE_SMSCODE: '/sendSmsCode4Activate',
  QUERY_USER_ORDER_BY_MOBILE: '/queryUserOrderByMobile',
  CHECK_SESSION: '/validToken',
  ASYNC_DELIVER_RECORD: '/autoAward/query',
  ASYNC_DELIVER_SAVE: '/autoAward/save',
  SHARE_TOKEN: '/getShareToken',
  GAME_CURRENCY_CONFIG: '/config/productList',
  GAME_CURRENCY_USER: '/queryAccount',
  GAME_CURRENCY_EXCHANGE_CHECK: '/exchangeCheck',
  GAME_CURRENCY_EXCHANGE: '/exchange',
  GAME_CURRENCY_ROLE_LIST: '/queryAmsRoles',

  // wuji
  WUJI_PAGE_CONFIG: '/config/getSubscribePage',
  WUJI_SUPPLIER_CONFIG: '/config/getSupplier',
  WUJI_ACTIVITY_CONFIG: '/config/getActivity',
  WUJI_ORDER_GOODS_CONFIG: '/config/getActivityPopImg',
  WUJI_GET_ALL_PRIZES: '/config/getAllPrizesByActId',

  // node
  COMMON_PRIZE_LIST: '/mallOrder/getUserLotteryList',
  UNUSED_FRAGMENT_PRIZE_LIST: '/mallOrder/getUnusedFragmentList',
  USED_FRAGMENT_PRIZE_LIST: '/mallOrder/getUsedFragmentList',
  AWARD_FUSION_PRIZE: '/mallOrder/awardFusionPrize',
  AWARD_PHYSICAL_GIFT: '/mallOrder/awardPhysicalGift',
  PRIZE_DETAIL: '/wuji/getPrizeDetail',
  SIGN_IN_TASK: '/activity/getSignInTask',
  ACTIVITY_DETAIL: '/wuji/getActivityDetail', // 获取奖池活动详情

  // receive free gift
  FREE_GIFT_SMS_CODE: '/sendSmsCode4FreeGift',
  RECEIVE_FREE_GIFT: '/freeGift',
  RECEIVE_FREE_GIFT_WIHTOUT_VALID: '/noValidFreeGift',
  SIGN_IN: '/signin',
  QUERY_SUBSCRIBE_FAIL_REASON: '/querySubscribeFailReason',

  // 限时活动
  TOP_ORDER_RECORD: '/getRecentOrderMobile',
  GET_PRIZE_POOL_STATUS: '/getPrizePoolStock',
  GET_PRIZE_POOL_STATUS_V2: '/getPrizePoolRemain',

  // IC Mobile
  GET_LATEST_AUTH_INFO: '/getLatestAuthInfo',
};
